import type { RoleType } from '@hit-game/shared/enums';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';
import { FullScreenLoader } from './common/FullScreenLoader';

interface ProtectedRouteProps {
  children: ReactNode;
  allowedRoles?: RoleType[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { user, loading } = useAuth();

  // Chưa biết đã đăng nhập hay chưa thì KHÔNG được redirect — làm vậy sẽ đá
  // người dùng về /login mỗi lần F5 trong lúc đang xác thực phiên.
  if (loading) return <FullScreenLoader />;

  if (!user) return <Navigate to="/login" replace />;

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={`/${user.role.toLowerCase()}`} replace />;
  }

  return <>{children}</>;
}
